
export interface IUserInfo {
    firstName?: string;
    lastName?: string;
    gender?: string;
    /** date of birth */
    dob?: Date | number;
    emailAddress?: string;
    newEmailAddress?: string;
    socialNetwork?:string;
    authInfo?: UserAuthInfo;
    // 是否允许修改网站账号(唯一标识账号)
    isAllowUpdateUserName: boolean;
}

export class UserAuthInfo {
    // 账户类型
    provider: string;
    // 微信头像
    headImgUrl?: string;
    // 微信昵称
    nickName?: string;
    // 微信登录是否每次都获取最新的头像和昵称
    updateInfoOnLogin?: boolean;
    // 邮箱
    // emailAddress?: string;
    // 邮箱登录旧密码
    newPassword?: string;
    // 邮箱登录新密码
    oldPassword?: string;
}